<template>
  <div class="wallet subscribed-user row mt-4 mx-2">
    <section class="wallet-shadow start col-xxs-12 col-xs-6 d-flex flex-column pt-4 justify-content-end">
      <div class="d-flex">
        <UserProfileSubscribedUserVoucherCard :subscription-plan="subscriptionPlan" :user="this.user" />
      </div>
      <div class="wallet-tip" />
      <div class="d-flex mt-3 flex-column">
        <div class="wallet-tip seperator position-absolute" />
        <!-- <UserProfileSubscribedUserReferral :ReferUrl="ReferUrl"></UserProfileSubscribedUserReferral> -->
        <UserProfilePaymentHistoryCard @ShowPaymentHistory="ShowPaymentHistory()" />
      </div>
      <div class="wallet-tip" />
      <div class="py-3" />
      <!-- <a href="#" @click="ShowPaymentHistory()" class="text-decoration-none payment-history py-3 d-inline">
            {{$t('UserProfile.Wallet.SubscribedUser.PaymentHistory')}}
      </a>-->
    </section>
    <section class="wallet-shadow end p-3 col-xxs-12 col-xs-6">
      <div class="description p-3 m-2 mb-3 rounded">
        <h4 class="line-height-2">
          {{ $t('UserProfile.Wallet.SubscribedUser.CurrentBalance') }}
          {{ accounting.CurrentBalance }}
          {{ $t('UserProfile.Wallet.ChargeAccount.PriceType') }}
        </h4>
        <p class="mt-4 mb-0" v-html="$t('UserProfile.Wallet.SubscribedUser.Description')" />
      </div>
      <UserProfileChargeWallet class="mx-2" :HideGateways="true" />
    </section>
  </div>
</template>

<script>
import UserProfilePaymentHistoryCard from '@/components/UserProfilePaymentHistoryCard.vue'
import UserProfileSubscribedUserReferral from '@/components/UserProfileSubscribedUserReferral.vue'
import UserProfileSubscribedUserVoucherCard from '@/components/UserProfileSubscribedUserVoucherCard.vue'
import UserProfileChargeWallet from '@/components/UserProfileChargeWallet.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'UserProfileSubscribedUserWallet',
  components: {
    UserProfileChargeWallet,
    UserProfileSubscribedUserVoucherCard,
    UserProfileSubscribedUserReferral,
    UserProfilePaymentHistoryCard
  },
  props: {
    accounting: Object,
    subscriptionPlan: Object,
    referUrl: String,
    user: Object
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      userWalletBalance: 'order/currentBalance'
      // userSubscriptions: "subscription/userSubscriptions"
    })
  },
  methods: {
    ...mapActions({
      getUserBalance: 'order/setCurrentBalance'
      // loadUserSubscriptionPlan:"subscription/getUserStatus"
    }),
    ShowPaymentHistory () {
      this.$emit('ShowPaymentHistory')
    }
  },
  created () {
    this.getUserBalance().then(response => {
      this.accounting.CurrentBalance = (response.body.result.balance) / 10
    })
    // this.SubscriptionPlan = this.userSubscriptions[0];
  },
  mounted () {
    // this.getUserBalance().then(response=>{
    //   this.Accounting.CurrentBalance = response.body.result.balance;
    // })
    // this.SubscriptionPlan = this.userSubscriptions[0];
  }
}
</script>
